<template>
	<page>
		<c-tab-list ref="tabList" class="factory-tab" :tabs="tabList" :immediate="false" type="border-tab" @change="tabHandle"></c-tab-list>

		<div class="factory" :class="{'flex-grow': currentTab != 1}">
			<div v-if="currentTab==1">
				<c-form unit-width="100%" ref="systemConfigForm" >
					<c-title>推送模式</c-title>
					<c-form-item label="工单推送CRM" tip="默认全部推送，非生产环境请启用仅推送测试标签单据模式">
						<c-radio-group v-model="work_order_push_crm_model" name="work_order_push_crm_model" :options="pushCrmModelDic" :disabled="!auth('b_system_config_edit')"></c-radio-group>
					</c-form-item>

					<div class="factory-handle flex">
						<c-button v-if="auth('b_system_config_edit')" size="form" color="main" hollow @click="submitSystemConfig">保存配置</c-button>
					</div>
				</c-form>
			</div>

			<div v-if="currentTab==2" class="flex">
				<c-form class="flex-grow" unit-width="100%" ref="noticeConfigForm" style="max-width: 750px;">
					<c-title>工单服务开始提醒</c-title>

					<c-form-item label="提前天数" tip="提前 N 天发送工单提醒，默认 1 天">
						<c-input type="stepper" v-model="work_order_remind_days" decimal="0" :range="[1,99]" step="1" step-controls="side" append-text="天" :disabled="!auth('b_system_config_edit')"></c-input>
					</c-form-item>

					<c-title>工单超期未派单提醒</c-title>

					<c-form-item label="超期阈值 (小时)" tip="超期 N 小时未派单发送预警，默认 2 小时">
                        <c-input type="stepper" v-model="work_order_overdue_threshold" decimal="0" :range="[1,99]" step="1" step-controls="side" append-text="时" :disabled="!auth('b_system_config_edit')"></c-input>
					</c-form-item>
                    <c-form-item label="预警间隔 (小时)" tip="同一工单预警间隔 N 小时，默认 24 小时">
                        <c-input type="stepper" v-model="work_order_warning_interval" decimal="0" :range="[1,99]" step="1" step-controls="side" append-text="时" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>
                    <c-form-item label="预警最大次数" tip="同一工单最大预警次数，默认 3 次">
                        <c-input type="stepper" v-model="work_order_warning_max_count" decimal="0" :range="[1,99]" step="1" step-controls="side" append-text="次" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>

                    <div class="factory-handle flex">
						<c-button v-if="auth('b_system_config_edit')" size="form" color="main" hollow @click="submitNoticeConfig">保存配置</c-button>
					</div>
				</c-form>
			</div>

            <div v-if="currentTab==3" class="flex">
                <c-form class="flex-grow" unit-width="100%" ref="orderConfigForm" style="max-width: 750px;">
                    <c-title>工单报销配置</c-title>
                    <c-form-item label="报销有效期" tip="工单完工后，允许报销的有效期天数">
                        <c-input type="stepper" v-model="reimbursement_duration_days" decimal="0" :range="[1,99]" step="1" step-controls="side" append-text="天" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>

                    <c-title>工单自动派单配置</c-title>
                    <c-form-item label="自动派单范围" tip="工单创建后，预约时间在此天数内的工单将自动派单">
                        <c-input type="stepper" v-model="auto_dispatch_days" decimal="0" :range="[1,99]" step="1" step-controls="side" append-text="天" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>

                    <c-title>工单打卡配置</c-title>
                    <c-form-item label="工单打卡范围" tip="打卡时与客户位置的有效距离范围，10-1000米">
                        <c-input type="stepper" v-model="attendance_range_meter" decimal="0" :range="[10,1000]" step="10" step-controls="side" append-text="米" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>
                    <c-form-item label="上班时间" tip="每日上班时间，格式 HH:mm">
                        <c-input v-model="work_time_start" placeholder="请输入上班时间，格式 HH:mm" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>
                    <c-form-item label="下班时间" tip="每日下班时间，格式 HH:mm">
                        <c-input v-model="work_time_end" placeholder="请输入下班时间，格式 HH:mm" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>
                    <c-form-item label="午休开始时间" tip="午休开始时间，格式 HH:mm">
                        <c-input v-model="work_time_lunch_start" placeholder="请输入午休开始时间，格式 HH:mm" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>
                    <c-form-item label="午休结束时间" tip="午休结束时间，格式 HH:mm">
                        <c-input v-model="work_time_lunch_end" placeholder="请输入午休结束时间，格式 HH:mm" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>
                    <c-form-item label="加班缓冲期" tip="单位：分钟，下班后多久内不算加班">
                        <c-input type="stepper" v-model="work_time_overtime_buffer" decimal="0" :range="[0,999]" step="1" step-controls="side" append-text="分钟" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>

                    <c-title>处理单打印配置</c-title>
                    <c-form-item label="CRM处理单打印模板名称" tip="客诉工单打印处理单时，使用的CRM打印模板名称，默认：用户意见处理单">
                        <c-input v-model="crm_complaint_print_template_name" placeholder="请输入CRM打印模板名称" :disabled="!auth('b_system_config_edit')"></c-input>
                    </c-form-item>

                    <div class="factory-handle flex">
                        <c-button v-if="auth('b_system_config_edit')" size="form" color="main" hollow @click="submitOrderConfig">保存配置</c-button>
                    </div>
                </c-form>
            </div>
		</div>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		components: {
		},

		data() {
			return {
				currentTab: 1,
                work_order_push_crm_model:1,
                work_order_remind_days: 1,
                work_order_overdue_threshold: 2,
                work_order_warning_interval: 24,
                work_order_warning_max_count: 3,
                reimbursement_duration_days: 3,
                auto_dispatch_days: 7,
                attendance_range_meter: 500,
                crm_complaint_print_template_name: '用户意见处理单',
                work_time_start: '08:00',
                work_time_end: '17:00',
                work_time_lunch_start: '12:00',
                work_time_lunch_end: '13:00',
                work_time_overtime_buffer: 30,
			}
		},

		computed: {
			...mapState(['systemConfig', 'userInfo', 'saasInfo', 'pushCrmModelDic']),
			...mapGetters(['freeEdition']),

			tabList() {
				let list = [];
				list.push({"value":1, "name": "系统配置"});
				list.push({"value":2, "name": "通知配置"});
                list.push({"value":3, "name": "工单配置"});
				return list;
			},
		},

		mounted() {
			//默认选中第一个选项卡
			this.$refs.tabList.changeIndex(0);
			//查询系统配置
			this.getSystemConfig();
		},

		methods: {
			tabHandle(tab) {
				this.currentTab = tab.value;
			},

			/****查询系统配置信息*****/
			getSystemConfig(){
				this.request({
					url: '/sys_saas/get/sys/config',
					success: data => {
						data.forEach(item => {
                            if(item.config_item_code == 'work_order_push_crm_model'){
								this.work_order_push_crm_model = item.config_item_value;
							}
                            if(item.config_item_code == 'work_order_remind_days'){
								this.work_order_remind_days = item.config_item_value;
							}
                            if(item.config_item_code == 'work_order_overdue_threshold'){
								this.work_order_overdue_threshold = item.config_item_value;
							}
                            if(item.config_item_code == 'work_order_warning_interval'){
								this.work_order_warning_interval = item.config_item_value;
							}
                            if(item.config_item_code == 'work_order_warning_max_count'){
								this.work_order_warning_max_count = item.config_item_value;
							}
                            if(item.config_item_code == 'reimbursement_duration_days'){
                                this.reimbursement_duration_days = item.config_item_value;
                            }
                            if(item.config_item_code == 'auto_dispatch_days'){
                                this.auto_dispatch_days = item.config_item_value;
                            }
                            if(item.config_item_code == 'attendance_range_meter'){
                                this.attendance_range_meter = item.config_item_value;
                            }
                            if(item.config_item_code == 'crm_complaint_print_template_name'){
                                this.crm_complaint_print_template_name = item.config_item_value;
                            }
                            if(item.config_item_code == 'WORK_TIME_START'){
                                this.work_time_start = item.config_item_value;
                            }
                            if(item.config_item_code == 'WORK_TIME_END'){
                                this.work_time_end = item.config_item_value;
                            }
                            if(item.config_item_code == 'WORK_TIME_LUNCH_START'){
                                this.work_time_lunch_start = item.config_item_value;
                            }
                            if(item.config_item_code == 'WORK_TIME_LUNCH_END'){
                                this.work_time_lunch_end = item.config_item_value;
                            }
                            if(item.config_item_code == 'WORK_TIME_OVERTIME_BUFFER'){
                                this.work_time_overtime_buffer = item.config_item_value;
                            }
						});
					}
				});
			},
			/**
			 * 保存系统配置
			 */
			submitSystemConfig() {
				this.$refs.systemConfigForm.submit({
					url: '/sys_saas/set/sys/config',
					rule: {
					},
					dataFormatter: data => {
						var system_config_list = [];
						var obj0 = {
							config_item_name:'工单推送CRM模式',
							config_item_code:'work_order_push_crm_model',
							config_item_type:7,
							config_item_value:this.work_order_push_crm_model||2,
							config_item_remark: '1-全部推送 2-仅推送测试标签单据 3-关闭推送'
						}
						system_config_list.push(obj0);
						return {
							system_config_list:system_config_list
						};
					},
					success: () => {
						this.$message({
							message: '配置成功'
						});
                        //更新全局配置
                        this.$store.dispatch('updateSystemConfig');  // 更新配置
					}
				});
			},

			/**
			 * 保存通知配置
			 */
			submitNoticeConfig() {
				var submitFlag = true;
                if (!this.work_order_remind_days){
                    submitFlag = false;
                    this.$message({
                        message: '【工单服务开始提醒】提前天数未配置',
                        type: 'warn'
                    });
                }
                if (submitFlag && (!this.work_order_overdue_threshold || !this.work_order_warning_interval || !this.work_order_warning_max_count)){
                    submitFlag = false;
                    this.$message({
                        message: '【工单超期未派单提醒】存在未配置项，请检查',
                        type: 'warn'
                    });
                }
				if (submitFlag){
					this.$refs.noticeConfigForm.submit({
						url: '/sys_saas/set/sys/config',
						rule: {
						},
						dataFormatter: data => {
							return this.handleSubmitData(data);
						},
						success: () => {
							this.$message({
								message: '配置成功'
							});
							//更新全局配置
							this.$store.dispatch('updateSystemConfig');  // 更新配置
						}
					});
				}
			},
			//构造提交数据
			handleSubmitData(data){
				/***********拼装最终的返回数据********/
				var system_config_list = [];

				var obj1 = {
					config_item_name:'工单提醒提前天数',
					config_item_code:'work_order_remind_days',
					config_item_type:2,
					config_item_value:this.work_order_remind_days,
					config_item_remark: '提前 N 天发送工单提醒，默认 1 天'
				}
				var obj2 = {
					config_item_name:'工单超期未派单阈值 (小时)',
					config_item_code:'work_order_overdue_threshold',
					config_item_type:2,
					config_item_value:this.work_order_overdue_threshold,
					config_item_remark: '超期 N 小时未派单发送预警，默认 2 小时'
				}
				var obj3 = {
					config_item_name:'工单未派单预警间隔 (小时)',
					config_item_code:'work_order_warning_interval',
					config_item_type:2,
					config_item_value:this.work_order_warning_interval,
					config_item_remark:'同一工单预警间隔 N 小时，默认 24 小时'
				}
                var obj4 = {
                    config_item_name:'工单未派单预警最大次数',
                    config_item_code:'work_order_warning_max_count',
                    config_item_type:2,
                    config_item_value:this.work_order_warning_max_count,
                    config_item_remark:'同一工单最大预警次数，默认 3 次'
                }

				system_config_list.push(obj1);
				system_config_list.push(obj2);
				system_config_list.push(obj3);
                system_config_list.push(obj4);
				return {
					system_config_list:system_config_list
				};
			},
            submitOrderConfig() {
                if (!this.crm_complaint_print_template_name || !this.crm_complaint_print_template_name.trim()) {
                    this.$message({
                        message: 'CRM处理单打印模板名称不能为空',
                        type: 'warn'
                    });
                    return;
                }
                this.$refs.orderConfigForm.submit({
                    url: '/sys_saas/set/sys/config',
                    rule: {
                    },
                    dataFormatter: data => {
                        var system_config_list = [];
                        system_config_list.push({
                            config_item_name:'报销有效期',
                            config_item_code:'reimbursement_duration_days',
                            config_item_type:2,
                            config_item_value:this.reimbursement_duration_days||7,
                            config_item_remark: '工单完工后，允许报销的天数'
                        });
                        system_config_list.push({
                            config_item_name:'自动派单范围',
                            config_item_code:'auto_dispatch_days',
                            config_item_type:2,
                            config_item_value:this.auto_dispatch_days||7,
                            config_item_remark: '工单创建后，预约时间在此天数内的工单将自动派单，默认 7 天'
                        });
                        system_config_list.push({
                            config_item_name:'考勤打卡范围 (米)',
                            config_item_code:'attendance_range_meter',
                            config_item_type:2,
                            config_item_value:this.attendance_range_meter||100,
                            config_item_remark: '员工打卡时与考勤点的有效距离范围，默认 100 米'
                        });
                        system_config_list.push({
                            config_item_name:'CRM处理单打印模板名称',
                            config_item_code:'CRM_COMPLAINT_PRINT_TEMPLATE_NAME',
                            config_item_type:1,
                            config_item_value:this.crm_complaint_print_template_name.trim(),
                            config_item_remark: '客诉工单打印处理单时使用的CRM打印模板名称，默认：用户意见处理单'
                        });
                        system_config_list.push({
                            config_item_name:'加班缓冲期',
                            config_item_code:'WORK_TIME_OVERTIME_BUFFER',
                            config_item_type:2,
                            config_item_value:this.work_time_overtime_buffer||30,
                            config_item_remark: '单位：分钟，下班后多久内不算加班，默认 30 分钟'
                        });
                        system_config_list.push({
                            config_item_name:'上班时间',
                            config_item_code:'WORK_TIME_START',
                            config_item_type:1,
                            config_item_value:this.work_time_start||'08:00',
                            config_item_remark: '每日上班时间，格式 HH:mm'
                        });
                        system_config_list.push({
                            config_item_name:'下班时间',
                            config_item_code:'WORK_TIME_END',
                            config_item_type:1,
                            config_item_value:this.work_time_end||'17:00',
                            config_item_remark: '每日下班时间，格式 HH:mm'
                        });
                        system_config_list.push({
                            config_item_name:'午休开始时间',
                            config_item_code:'WORK_TIME_LUNCH_START',
                            config_item_type:1,
                            config_item_value:this.work_time_lunch_start||'12:00',
                            config_item_remark: '午休开始时间，格式 HH:mm'
                        });
                        system_config_list.push({
                            config_item_name:'午休结束时间',
                            config_item_code:'WORK_TIME_LUNCH_END',
                            config_item_type:1,
                            config_item_value:this.work_time_lunch_end||'13:00',
                            config_item_remark: '午休结束时间，格式 HH:mm'
                        });
                        return {
                            system_config_list:system_config_list
                        };
                    },
                    success: () => {
                        this.$message({
                            message: '配置成功'
                        });
                        this.$store.dispatch('updateSystemConfig');
                    }
                })
            },
		}
	}
</script>

<style lang="stylus" scoped>
	.factory {
		border: 1px solid var(--unit-line);
		border-radius: 0 10px 10px 10px;
		border-top: none;
		padding: 26px;
		margin: 0 15px 15px;
		overflow: auto;
		background: #fff;

		&-tab {
			margin: 0 15px;

			>>> ul {
				padding-left: 0;
			}
		}

		&-handle {
			gap: 20px;
			margin-top: 20px;

			>>> .c-button {
				border-radius: 4px;
			}
		}
	}
</style>